import React, { FC } from 'react';

import BreakpointsService from 'src/explore/services/breakpoints';
import LogIn from 'src/prize/scenes/LogIn';

import styles from './index.module.sass';

export const Authentication: FC = () => {
  const isMobile = BreakpointsService.lessThan( 'sm' );

  return <LogIn className={styles.authentication} isMobile={isMobile} />;
};
